/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Vector3fPb } from "../../../../gen/eigen_lcm/Vector3f";
import { TriggerArgs_TimerCallback } from "../../trigger_args";

export const protobufPackage = "complimentary_actions";

export interface SimEventWindActionArgs {
  trigger:
    | TriggerArgs_TimerCallback
    | undefined;
  /** How long the wind should last. Infinite if < 0. Seconds. */
  duration: number;
  /** Constant wind. Units in m/s. X-axis facing east. */
  windVelocity:
    | Vector3fPb
    | undefined;
  /** How long to wait until starting the wind. Instant if <= 0. Seconds. */
  delay: number;
}

function createBaseSimEventWindActionArgs(): SimEventWindActionArgs {
  return { trigger: undefined, duration: 0, windVelocity: undefined, delay: 0 };
}

export const SimEventWindActionArgs = {
  encode(message: SimEventWindActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.trigger !== undefined) {
      TriggerArgs_TimerCallback.encode(message.trigger, writer.uint32(10).fork()).ldelim();
    }
    if (message.duration !== 0) {
      writer.uint32(21).float(message.duration);
    }
    if (message.windVelocity !== undefined) {
      Vector3fPb.encode(message.windVelocity, writer.uint32(26).fork()).ldelim();
    }
    if (message.delay !== 0) {
      writer.uint32(37).float(message.delay);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SimEventWindActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimEventWindActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trigger = TriggerArgs_TimerCallback.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.duration = reader.float();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.windVelocity = Vector3fPb.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.delay = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SimEventWindActionArgs {
    return {
      trigger: isSet(object.trigger) ? TriggerArgs_TimerCallback.fromJSON(object.trigger) : undefined,
      duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
      windVelocity: isSet(object.windVelocity) ? Vector3fPb.fromJSON(object.windVelocity) : undefined,
      delay: isSet(object.delay) ? globalThis.Number(object.delay) : 0,
    };
  },

  toJSON(message: SimEventWindActionArgs): unknown {
    const obj: any = {};
    if (message.trigger !== undefined) {
      obj.trigger = TriggerArgs_TimerCallback.toJSON(message.trigger);
    }
    if (message.duration !== 0) {
      obj.duration = message.duration;
    }
    if (message.windVelocity !== undefined) {
      obj.windVelocity = Vector3fPb.toJSON(message.windVelocity);
    }
    if (message.delay !== 0) {
      obj.delay = message.delay;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SimEventWindActionArgs>, I>>(base?: I): SimEventWindActionArgs {
    return SimEventWindActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SimEventWindActionArgs>, I>>(object: I): SimEventWindActionArgs {
    const message = createBaseSimEventWindActionArgs();
    message.trigger = (object.trigger !== undefined && object.trigger !== null)
      ? TriggerArgs_TimerCallback.fromPartial(object.trigger)
      : undefined;
    message.duration = object.duration ?? 0;
    message.windVelocity = (object.windVelocity !== undefined && object.windVelocity !== null)
      ? Vector3fPb.fromPartial(object.windVelocity)
      : undefined;
    message.delay = object.delay ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
